import { withRouter, useRouteMatch } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { useState, useEffect,useRef } from "react";
import PhoneInput from "react-phone-input-2";
import { flushCart } from "../redux/cartSlice";
import { auth, firestore, messaging,app, Api  } from "../provider/firebase";
import { signInWithPhoneNumber, RecaptchaVerifier } from "firebase/auth";
import {  doc,getDoc } from "firebase/firestore"; 
import axios from "axios";
import moment from 'moment-timezone';
import { calculateOrderPrice, exportLogo, getHostName, inputAlert, parsePrice, safeUrl, somethingWentWrong, successMessage } from "../provider/functions";
import { useFormPopup } from "../provider/FormPopupContext";
import { getToken,isSupported,getMessaging } from "firebase/messaging";
import MySelectBox from "../components/MySelectBox";
import MyTimePicker,{MyTimePicker2} from "../components/MyTimePicker";
import Swal from "sweetalert2";
export default withRouter(PayWebstore);

const styles = {
  pageContainer: {
    minHeight: '100vh',
    background: 'linear-gradient(180deg, #fafafa 0%, #f0f0f0 100%)',
    paddingBottom: 220,
  },
  header: {
    padding: '20px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  backButton: {
    width: 44,
    height: 44,
    borderRadius: 14,
    background: '#fff',
    border: 'none',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer',
    boxShadow: '0 2px 8px rgba(0,0,0,0.06)',
    fontSize: 18,
    color: '#333',
  },
  logoContainer: {
    maxHeight: 56,
    borderRadius: 16,
    overflow: 'hidden',
    boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
  },
  logo: {
    height: 56,
    width: 'auto',
    objectFit: 'contain',
  },
  stepsContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 8,
    padding: '8px 20px 24px',
  },
  step: {
    display: 'flex',
    alignItems: 'center',
    gap: 8,
  },
  stepNumber: {
    width: 32,
    height: 32,
    borderRadius: '50%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: 13,
    fontWeight: 600,
  },
  stepNumberActive: {
    background: '#000',
    color: '#fff',
  },
  stepNumberInactive: {
    background: 'rgba(0,0,0,0.08)',
    color: 'rgba(0,0,0,0.4)',
  },
  stepName: {
    fontSize: 13,
    fontWeight: 500,
  },
  stepDivider: {
    width: 32,
    height: 2,
    background: 'rgba(0,0,0,0.1)',
    borderRadius: 1,
  },
  formContainer: {
    padding: '0 16px',
  },
  formCard: {
    background: '#fff',
    borderRadius: 20,
    padding: 20,
    marginBottom: 16,
    boxShadow: '0 2px 12px rgba(0,0,0,0.04)',
    border: '1px solid rgba(0,0,0,0.04)',
  },
  sectionTitle: {
    fontSize: 13,
    fontWeight: 600,
    textTransform: 'uppercase',
    letterSpacing: '0.5px',
    marginBottom: 12,
    opacity: 0.7,
  },
  inputLabel: {
    fontSize: 14,
    fontWeight: 600,
    marginBottom: 8,
    display: 'block',
  },
  input: {
    width: '100%',
    padding: '14px 16px',
    borderRadius: 14,
    border: '1px solid rgba(0,0,0,0.1)',
    fontSize: 15,
    background: 'rgba(0,0,0,0.02)',
    outline: 'none',
    marginBottom: 16,
  },
  inputError: {
    borderColor: '#e53935',
    background: 'rgba(229, 57, 53, 0.04)',
  },
  select: {
    width: '100%',
    padding: '14px 16px',
    borderRadius: 14,
    border: '1px solid rgba(0,0,0,0.1)',
    fontSize: 15,
    background: 'rgba(0,0,0,0.02)',
    outline: 'none',
    marginBottom: 16,
    cursor: 'pointer',
    appearance: 'none',
    backgroundImage: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' fill='%23333' viewBox='0 0 16 16'%3E%3Cpath d='M8 11L3 6h10l-5 5z'/%3E%3C/svg%3E")`,
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'right 16px center',
  },
  textarea: {
    width: '100%',
    padding: '14px 16px',
    borderRadius: 14,
    border: '1px solid rgba(0,0,0,0.1)',
    fontSize: 15,
    background: 'rgba(0,0,0,0.02)',
    outline: 'none',
    marginBottom: 16,
    resize: 'vertical',
    minHeight: 100,
  },
  paymentGrid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(140px, 1fr))',
    gap: 10,
    marginTop: 8,
  },
  paymentButton: {
    padding: '14px 12px',
    borderRadius: 14,
    border: '2px solid rgba(0,0,0,0.1)',
    background: '#fff',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 8,
    cursor: 'pointer',
    fontSize: 13,
    fontWeight: 600,
    color: '#333',
  },
  paymentButtonActive: {
    borderColor: '#000',
    background: '#000',
    color: '#fff',
  },
  paymentIcon: {
    width: 24,
    height: 24,
    objectFit: 'contain',
  },
  alertBadge: {
    padding: '12px 16px',
    borderRadius: 12,
    background: 'rgba(229, 57, 53, 0.1)',
    color: '#e53935',
    fontSize: 13,
    fontWeight: 500,
    marginBottom: 16,
    display: 'block',
  },
  warningBadge: {
    padding: '10px 14px',
    borderRadius: 10,
    background: 'rgba(229, 57, 53, 0.1)',
    color: '#e53935',
    fontSize: 12,
    fontWeight: 500,
    marginTop: 10,
    display: 'block',
    lineHeight: 1.4,
  },
  bottomSheet: {
    position: 'fixed',
    bottom: 0,
    left: 0,
    right: 0,
    background: '#fff',
    borderRadius: '24px 24px 0 0',
    padding: '20px 20px 28px',
    boxShadow: '0 -4px 30px rgba(0,0,0,0.1)',
    zIndex: 100,
  },
  priceRow: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: 10,
  },
  priceLabel: {
    fontSize: 14,
    color: '#888',
    fontWeight: 500,
  },
  priceValue: {
    fontSize: 14,
    color: '#888',
    fontWeight: 500,
  },
  totalRow: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    paddingTop: 14,
    borderTop: '1px solid rgba(0,0,0,0.08)',
    marginBottom: 16,
  },
  totalLabel: {
    fontSize: 16,
    fontWeight: 600,
  },
  totalValue: {
    fontSize: 22,
    fontWeight: 700,
  },
  orderButton: {
    width: '100%',
    height: 56,
    borderRadius: 16,
    border: 'none',
    background: '#000',
    fontFamily: 'inherit',
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '0 8px 0 16px',
    outline: 'none',
    transition: 'opacity 0.15s, box-shadow 0.15s',
    gap: 8,
  },
  orderButtonDisabled: {
    opacity: 0.4,
    cursor: 'not-allowed',
  },
  discountRow: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: 10,
    padding: '8px 12px',
    background: 'rgba(229, 57, 53, 0.08)',
    borderRadius: 10,
  },
  discountLabel: {
    fontSize: 14,
    color: '#e53935',
    fontWeight: 600,
  },
  discountValue: {
    fontSize: 14,
    color: '#e53935',
    fontWeight: 700,
  },
};

function PayWebstore({ history }) {
  const dispatch = useDispatch();
  let match = useRouteMatch();
  const { openFormPopup } = useFormPopup();
  const [loading, setloading] = useState(false);
  const [selfservice, setselfservice] = useState(false);
  const [adsoyad, setadsoyad] = useState("");
  const [phoneNumber, setphoneNumber] = useState("");
  const [user, setuser] = useState(false);
  const [il, setil] = useState("");
  const [ilce, setilce] = useState("");
  const [mahalle, setmahalle] = useState("");
  const [adres, setadres] = useState("");
  const [odemeyontemi, setodemeyontemi] = useState("");
  const [deactiveTimes, setdeactiveTimes] = useState([]);
  const [masano, setmasano] = useState("");
  const [bildirim, setbildirim] = useState("");
  const language = useSelector((state) => state.language.data);
  const serverReducer = useSelector((state) => state.server.data);
  const categories = useSelector((state) => state.categories.data);
  const currency = serverReducer.currency;
  const cart = useSelector((state) => state.cart.data);
  const toplam = parseFloat( parseFloat( cart.map(v=>calculateOrderPrice(v)).reduce((a, b) => a + b, 0)).toFixed(2))
  const {freekargo,kargo,min,opened,payments,deliveryType,limits,closed,alertmessage} = serverReducer.webstore || {open:false,min:0,kargo:0,freekargo:0,payments:[],deliveryType:[],limits:{},closed:"00:00"}
  const kargoFiyati = parsePrice( !selfservice ? (toplam>freekargo ? 0 : kargo) : 0);
  const tables = useSelector((state) => state.tables.data);
  const [lat, setLat] = useState(0);
  const [teslimattype, setteslimattype] = useState("");
  const [teslimzamanlari, setteslimzamanlari] = useState([]);
  const [teslim, setteslim] = useState("now");
  const [lng, setLng] = useState(0);
  const onlinePayments = serverReducer.onlinePayments ?? [];

  // İndirim hesaplama
  const toplamIndirim = cart.reduce((acc, item) => {
    const product = item.product;
    if (product.originalPrice && product.originalPrice > product.price) {
      return acc + ((product.originalPrice - product.price) * item.quantity);
    }
    return acc;
  }, 0);

  async function onSignInSubmit(){
    if(!selfservice && (teslimattype=="" || adsoyad.length<3 || ilce.length<3 || mahalle.length<3 || adres.length<3)){
      return somethingWentWrong( language.hata,language.bilgileri_doldurun)
    }
    if(teslimattype=="table" && masano.length<1){
      return Swal.fire("Hata!", language.masa_zorunlu, "error");
    }
    setloading(true);
    const access_token = await  auth.currentUser?.getIdToken();
    Api.post("/paketGonder",{
      access_token,
      server: match.params.server ? match.params.server : getHostName(),
      cart,
      scheduledDate:teslim,
      name: adsoyad,
      selfservice,
      latitude:lat,
      longitude:lng,
      phone:phoneNumber,
      address:teslimattype=="table" ? masano :adres,
      region:teslimattype=="table" ?"":mahalle,
      district:teslimattype=="table" ?"":ilce,
      notification:bildirim,
      county:teslimattype=="table" ?"":il,
      paymentNote:odemeyontemi,
      paymentMethod:odemeyontemi
    }).then((res)=>{
      if (res.data.form && Array.isArray(res.data.form)) {
        openFormPopup(res.data.form, res.data.formTitle, res.data.formDescription);
        return;
      }
      if (res.data.error) {
        if(res.data.error=="recaptcha-error"){
          return Swal.fire("Recaptcha!", language.recaptcha, "error");
        }if (res.data.error == "server-not-found") {
          return Swal.fire("Hata!", language.restorant_not_found, "error");
        }else if (res.data.error == "cart-not-found") {
          history.goBack();
          return Swal.fire("Hata!", language.sepette_urun_yok, "error");
        }else if (res.data.error == "name-not-found") {
          return Swal.fire("Hata!", language.ad_zorunlu, "error");
        }else if (res.data.error == "table-not-found") {
          return Swal.fire("Hata!", language.masa_zorunlu, "error");
        }else if (res.data.error == "webstoreclosed") {
          return somethingWentWrong("Hata!", language.webstore_kapali_baslik, "error");
        }else if (res.data.error == "minprice") {
          return somethingWentWrong("Hata!", language.minimum_tutar_altinda_baslik, "error");
        }else if (res.data.error == "paymentmethod") {
          return somethingWentWrong("Hata!", language.odeme_yontemi_zorunlu, "error");
        }
      }
      if (res.data.success == true) {
        if(res.data.url){
          // Sunucudan gelen yonlendirme adresi de sema denetiminden gecer (bkz. safeUrl).
          const payTarget = safeUrl(res.data.url);
          if (payTarget) window.location = payTarget;
          return;
        }
        history.replace((match.params.server?"/"+match.params.server:"")+"/"+match.params.table+"/welcome")
        dispatch(flushCart());
        return successMessage(
          language.basarili,
          language.siparis_iletildi,
          "success"
        );
      }
      return somethingWentWrong(
       language.hata,
        language.birseyler_ters_gidiyor,
        "error"
      );
    })
    .finally(()=>setloading(false))
  }
 
  useEffect( ()=>{
    requestLocation();
    [...cart].length==0 &&  history.replace((match.params.server?"/"+match.params.server:"")+"/"+match.params.table+"/welcome")

    const unsubscribe = auth.onAuthStateChanged(userData=>{
      if(userData) {
       getDoc( doc(firestore,"users/"+userData.uid)).then(snapshot=>{
         if(snapshot.exists){
           !String(snapshot.data()?.address).toLowerCase().includes("self") && setadres(snapshot.data()?.address || "")
           !String(snapshot.data()?.county).toLowerCase().includes("self") && setil(snapshot.data()?.county || "")
           !String(snapshot.data()?.district).toLowerCase().includes("self") && setilce(snapshot.data()?.district || "")
           !String(snapshot.data()?.region).toLowerCase().includes("self") && setmahalle(snapshot.data()?.region || "")
         }
       })
        setuser(userData)
        setphoneNumber(userData.phoneNumber)
        setadsoyad(userData.displayName || "");
      }
    })
    if(onlinePayments.length>0) setodemeyontemi(onlinePayments[0].value)
    return ()=>unsubscribe();
  },[])
 

  useEffect(() => {
    var teslimZamanlari = [{label: language.siparis_teslimati_en_kisa_zamanda, value: "now"}];
    const saat = moment.tz(new Date(), serverReducer.timezone).add(1, "hour").minute(0);
    const suan = moment.tz(new Date(), serverReducer.timezone);
    const acilis = moment.tz(moment(opened).year(suan.year()).month(suan.month()).date(suan.date()), serverReducer.timezone);
    const kapanis = moment.tz(moment(closed).year(suan.year()).month(suan.month()).date(suan.date()), serverReducer.timezone);
    
    for (let index = 0; index < 25; index++) {
      const add = saat.add(15, "minute");
      if(add.isBetween(acilis, kapanis)) {
        teslimZamanlari.push({label: add.format("HH:mm"), value: add.valueOf()});
      }
    }
    
    if(limits && Object.keys(limits).length === 0) {
      setteslimzamanlari(teslimZamanlari);
      return;
    }

    async function main() {
      try {
        const response = await Api.post("/CheckLimits",{
          server: match.params.server ? match.params.server : getHostName(),
          cart
        });

          const deactiveTimes = response.data.deactiveTimes;
          const deactiveTime = deactiveTimes.map(v => v.time);
          
          setdeactiveTimes(deactiveTimes.map(v => ({
            ...v,
            ...categories.find(val => val.id === v.cat)
          })));
          
          setteslimzamanlari(teslimZamanlari.map(value => ({
            ...value,
            isDisabled: deactiveTime.includes(moment.tz(value.value, serverReducer.timezone).format("HH:mm"))
          })));
        
      } catch (error) {
          setteslimzamanlari(teslimZamanlari);
      }
    }

    main();

  }, [limits]);

  async function requestLocation() {
    try {
      const status = await navigator.permissions.query({ name: 'geolocation' });
      if (status.state === 'denied') {
        return;
      }
    } catch { 
      console.log('Permissions API desteklenmiyor.');
    }

    navigator.geolocation.getCurrentPosition(
      ({ coords }) => {
        console.log('Konum:', coords);
        setLat(coords.latitude);
        setLng(coords.longitude);
      },
      async (err) => {
        console.error('Konum alınamadı:', err.message);
        if (err.code == 2) {
          try {
            await new Promise(res => setTimeout(res, 3000));
            navigator.geolocation.getCurrentPosition(
              pos => {
                setLat(pos.coords.latitude);
                setLng(pos.coords.longitude);
                console.log('Yaklaşık konum', pos.coords)
              },
              e => console.warn('Hâlâ alınamadı:', e.message),
              { ...{}, enableHighAccuracy: false }
            );
          } catch { /* ignore */ }
        } else if (err.code === err.PERMISSION_DENIED) {
          alert('Konum izni verilmedi—tarayıcı ayarlarını kontrol edin.');
        } else if (err.code === err.TIMEOUT) {
          alert('Konum isteği zaman aşımına uğradı, tekrar deneyin.');
        }
     
      },
      {
        enableHighAccuracy: true,
        timeout: 10_000,
        maximumAge: 5_000
      }
    );
  }

  return (
    <div style={styles.pageContainer}>
      {/* Header */}
      <div style={styles.header}>
        <button style={styles.backButton} onClick={history.goBack}>
          <i className="fa fa-arrow-left" />
        </button>
        <div style={{...styles.logoContainer, background: '#fafafa', boxShadow: 'none'}}>
          <img
            style={styles.logo}
            src={serverReducer.image ? serverReducer.image : "../"+exportLogo(serverReducer.host)}
            alt="Logo"
          />
        </div>
        <div style={{width: 44}}></div>
      </div>

      {/* Steps */}
      <div style={styles.stepsContainer}>
        <div style={styles.step}>
          <span style={{...styles.stepNumber, ...styles.stepNumberInactive}}>1</span>
          <span style={{...styles.stepName, color: '#111', opacity: 0.5}}>{language.menu}</span>
        </div>
        <div style={styles.stepDivider}></div>
        <div style={styles.step}>
          <span style={{...styles.stepNumber, ...styles.stepNumberInactive}}>2</span>
          <span style={{...styles.stepName, color: '#111', opacity: 0.5}}>{language.sepet}</span>
        </div>
        <div style={styles.stepDivider}></div>
        <div style={styles.step}>
          <span style={{...styles.stepNumber, ...styles.stepNumberActive, background: "#e74c3c" || '#000'}}>3</span>
          <span style={{...styles.stepName, color: '#e74c3c'}}>{language.odeme || "Payment"}</span>
        </div>
      </div>

      {/* Form */}
      <div style={styles.formContainer}>
        {/* Kişisel Bilgiler */}
        <div style={styles.formCard}>
          <div style={{...styles.sectionTitle, color: '#111'}}>
            <i className="fa fa-user" style={{marginRight: 8}}></i>
            {language.kisisel_bilgiler || "Kişisel Bilgiler"}
          </div>
          
          <label style={{...styles.inputLabel, color: '#111'}}>{language.ad}</label>
          <input
            style={{...styles.input, ...(adsoyad.length<3 ? styles.inputError : {})}}
            placeholder="Joe Doe"
            value={adsoyad}
            onChange={(e) => setadsoyad(e.target.value)}
          />
        </div>

        {/* Teslimat */}
        <div style={styles.formCard}>
          <div style={{...styles.sectionTitle, color: '#111'}}>
            <i className="fa fa-truck" style={{marginRight: 8}}></i>
            {language.teslimat}
          </div>
          
          <label style={{...styles.inputLabel, color: '#111'}}>{language.teslimat_tipi || "Teslimat Tipi"}</label>
          <select 
            style={{...styles.select, ...(teslimattype=="" ? styles.inputError : {})}}
            onChange={(e)=>{
              if(e.target.value=="table"){setselfservice(true); setadres(language.masaya_siparis)}
              if(e.target.value=="packet"){setselfservice(true); setadres(language.paket_siparis)}
              if(e.target.value=="home"){setselfservice(false);}
              setteslimattype(e.target.value)
            }}
          >
            <option value="">{language.sec}</option>
            {(deliveryType ?? []).includes("table") && <option value="table">{language.masaya_siparis}</option>}
            {(deliveryType ?? []).includes("packet") && <option value="packet">{language.paket_siparis}</option>}
            {!(deliveryType ?? []).includes("hidehome") && <option value="home">{language.adrese_gelsin}</option>}
          </select>

          {teslimattype=="table" && (
            <>
              <label style={{...styles.inputLabel, color: '#111'}}>{language.masa_oda}</label>
              <select 
                style={{...styles.select, ...(masano.length<1 ? styles.inputError : {})}}
                onChange={(e)=> setmasano(e.target.value)}
              >
                <option value="">{language.sec}</option>
                {[...tables].sort((a, b) => String(a).localeCompare(String(b), undefined, { numeric: true })).map((v,i)=><option key={i} value={v}>{v}</option>)}
              </select>
            </>
          )}

          {!selfservice && (
            <>
              <label style={{...styles.inputLabel, color: '#111'}}>{language.ilce}</label>
              <input
                style={{...styles.input, ...(ilce.length<2 ? styles.inputError : {})}}
                placeholder=""
                value={ilce}
                onChange={(e) => setilce(e.target.value)}
              />

              <label style={{...styles.inputLabel, color: '#111'}}>{language.mahalle}</label>
              <input
                style={{...styles.input, ...(mahalle.length<3 ? styles.inputError : {})}}
                placeholder=""
                value={mahalle}
                onChange={(e) => setmahalle(e.target.value)}
              />

              <label style={{...styles.inputLabel, color: '#111'}}>{language.adres}</label>
              <textarea
                style={{...styles.textarea, ...(adres.length<3 ? styles.inputError : {})}}
                placeholder=""
                value={adres}
                onChange={(e) => setadres(e.target.value)}
              />

              {alertmessage && (
                <span style={styles.alertBadge}>
                  <i className="fa fa-exclamation-circle" style={{marginRight: 8}}></i>
                  {alertmessage}
                </span>
              )}
            </>
          )}
        </div>

        {/* Teslimat Zamanı */}
        <div style={styles.formCard}>
          <div style={{...styles.sectionTitle, color: '#111'}}>
            <i className="fa fa-clock" style={{marginRight: 8}}></i>
            {language.siparis_teslimati}
          </div>
          
          <MySelectBox 
            options={teslimzamanlari}  
            onChange={(e)=>(e && e.value) && setteslim(e.value)}
            isSearchable={false} 
            value={teslimzamanlari.find(v=>v.value==teslim)} 
          />

          {deactiveTimes.map((v, i) => (
            <span key={i} style={styles.warningBadge}>
              <i className="fa fa-exclamation-triangle" style={{marginRight: 6}}></i>
              {v.time} itibarıyla yoğunluk nedeniyle {v.title} siparişlerinde gecikme yaşanmaktadır.
            </span>
          ))}
        </div>

        {/* Ödeme Yöntemi */}
        <div style={styles.formCard}>
          <div style={{...styles.sectionTitle, color: '#111'}}>
            <i className="fa fa-credit-card" style={{marginRight: 8}}></i>
            {language.odeme_yontemi}
          </div>
          
          <div style={styles.paymentGrid}>
            {onlinePayments.map((v,k) => (
              <button 
                key={k}
                style={{
                  ...styles.paymentButton,
                  ...(odemeyontemi==v.value ? {...styles.paymentButtonActive, background: "#e74c3c" || '#000', borderColor: "#e74c3c" || '#000'} : {})
                }}
                onClick={()=>setodemeyontemi(v.value)}
              >
                {v.icon && <img src={v.icon} style={styles.paymentIcon} alt="" loading="lazy" />}
                {v.title}
              </button>
            ))}
            {payments.map(v=>({title:v,value:v})).map((v,k) => (
              <button 
                key={k}
                style={{
                  ...styles.paymentButton,
                  ...(odemeyontemi==v.value ? {...styles.paymentButtonActive, background: "#e74c3c" || '#000', borderColor: "#e74c3c" || '#000'} : {})
                }}
                onClick={()=>setodemeyontemi(v.value)}
              >
                {v.title}
              </button>
            ))}
          </div>
        </div>
      </div>

      {/* Recaptcha */}
      <center style={{ paddingBottom: 20, display:'block' }}> 
        <div id="recaptcha-container" className="recaptcha-container"/>
      </center>

      {/* Bottom Sheet */}
      <div style={styles.bottomSheet}>
        {toplamIndirim > 0 && (
          <div style={styles.discountRow}>
            <span style={styles.discountLabel}>
              <i className="fa fa-tag" style={{marginRight: 6}}></i>
              {language.indirim || "İndirim"}
            </span>
            <span style={styles.discountValue}>-{parsePrice(toplamIndirim)} {currency}</span>
          </div>
        )}
        {kargoFiyati > 0 && (
          <div style={styles.priceRow}>
            <span style={styles.priceLabel}>{language.teslimat_ucreti}</span>
            <span style={styles.priceValue}>+{kargoFiyati} {currency}</span>
          </div>
        )}
        <button 
          style={{
            ...styles.orderButton,
            background: "#e74c3c" || '#000',
            boxShadow: `0 6px 28px ${"#e74c3c" || '#000'}60`,
            ...(loading || cart.length==0 ? styles.orderButtonDisabled : {})
          }}
          disabled={loading || cart.length==0}
          onClick={onSignInSubmit}
        >
          {loading ? (
            <div className="spinner-border spinner-border-sm text-light" role="status">
              <span className="sr-only">Loading...</span>
            </div>
          ) : (
            <>
              <div style={{display:'flex',alignItems:'center',gap:8,flexShrink:0}}>
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
                  <path d="M6 2L3 6v14a2 2 0 002 2h14a2 2 0 002-2V6l-3-4z" stroke="#fff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  <line x1="3" y1="6" x2="21" y2="6" stroke="#fff" strokeWidth="2" strokeLinecap="round"/>
                  <path d="M16 10a4 4 0 01-8 0" stroke="#fff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
                <span style={{fontSize:15,fontWeight:800,letterSpacing:'-0.3px',color:'#fff',whiteSpace:'nowrap'}}>{language.siparis_ver}</span>
              </div>
              <span style={{background:'rgba(255,255,255,0.2)',color:'#fff',borderRadius:10,padding:'7px 14px',fontSize:11,fontWeight:800,letterSpacing:'-0.2px',whiteSpace:'nowrap',lineHeight:1,flexShrink:0}}>
                {parsePrice(toplam + kargoFiyati)} {currency}
              </span>
            </>
          )}
        </button>
      </div>
    </div>
  );
}
